import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LoggerService } from '@app/core/services/logger.service';
import { DataForModalGeneric } from '@app/shared/models/data-for-modal-generic.model';
const logger = new LoggerService('ModalGenericInfComponent');
@Component({
  selector: 'dhl-modal-generic-inf',
  templateUrl: './modal-generic-inf.component.html',
  styleUrls: ['./modal-generic-inf.component.scss']
})
export class ModalGenericInfComponent {

  isVisibleModalSuccesPurchase!: boolean;
  @Input() showModalMakePurchase!: boolean;
  @Input() dataForModal!: DataForModalGeneric;
  @Output() execFunctionEmit = new EventEmitter<boolean>();
  @Output() isVisiblePurchaseEmit = new EventEmitter<boolean>();


  constructor(private readonly router: Router){

  }

  hiddenModalInfo(){
    this.isVisibleModalSuccesPurchase = false;
    this.isVisiblePurchaseEmit.emit(this.isVisibleModalSuccesPurchase);
  }

  handleChildVariableChange(newChildVariableValue: boolean) {
    this.isVisibleModalSuccesPurchase = newChildVariableValue;
  }

  executeFunctionConfirm(){
    this.execFunctionEmit.emit(true);
  }

  generateAction(){
    logger.debug("Ejecutando");
    if(this.dataForModal.redirectTo !== 'execFunction'){
      if(this.dataForModal.redirectTo !== ''){ // Es decir que si hay una reedireccion a la cual dirigir
        void this.router.navigate([this.dataForModal.redirectTo]);
      }else{
        // Es decir que solamente queremos que se quite el modal
        this.hiddenModalInfo();
      }
    }else{
      logger.debug("Ejecutando función");
      // Es decir que si hay una función que queremos ejecutar y que recibimos de execFunctionForBtnConfirm
      this.executeFunctionConfirm();
    }
  }
}
